import request from '@/utils/request'

// 分页查询合作方信息
export function getPageList(params) {
  return request({
    url: '/hrApi/cooperate',
    method: 'get',
    params: params
  })
}

// 获取合作方列表
export function getList(params) {
  return request({
    url: '/hrApi/cooperate/list',
    method: 'get',
    params: params
  })
}

// 新增或编辑合作方
export function saveOrUpdateData(data) {
  return request({
    url: '/hrApi/cooperate',
    method: 'post',
    data: data
  })
}

// 删除合作方
export function deleteData(id) {
  return request({
    url: '/hrApi/cooperate/' + id,
    method: 'delete'
  })
}

// 统计
export function statistics() {
  return request({
    url: '/hrApi/cooperate/statistics',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/cooperate.js